<template>
  <div class="price-regulator-page__content">
    <v-notification>
    </v-notification>
    <Modal
        :style="showModalAdd ? 'display: block' : 'display: none'"
        :show="showModalAdd"
        modal-class="withdrawal-funds-modal"
        @close="toggleShowModalAdd"
    >
      <template #body>
        <div class="modal-close" @close="toggleShowModalAdd"></div>
        <div class="modal-content">
          <div class="modal-title">{{ getLocalization('Are you sure you want to change') }}?</div>
          <div class="withdrawal-funds-modal__available">
            <div>{{getLocalization('Number of services to be changed')}}: - <span class="span-orange">{{searchList.length}}</span></div>
          </div>
          <div class="withdrawal-funds-modal__submit">
            <button
                class="button orange"
                @click="sendChangeAllWithLoader"
            >
              {{getLocalization('Yes')}}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <div class="price-regulator-page__title">
      <img src="/img/svg/header-user-menu/price-regulator.svg" alt="">
      <h1>{{ getLocalization('Price regulator') }}</h1>
    </div>
    <div class="price-regulator-page__filter">
      <div>
        <div class="--label">{{ getLocalization('Select a country') }}</div>
        <div id="common-multiselect">
          <multiselect
              v-model="country"
              @input="changeCountryId"
              :placeholder="getLocalization('Select a country')"
              label="title"
              track-by="title"
              :options='countriesList'
              :option-height="40"
              :show-labels="false"
              :allow-empty="false"
          >
            <template slot="option" slot-scope="props">
              <img :src="props.option.img_path">
              <span>{{ props.option.title }}</span>
            </template>
          </multiselect>
        </div>
      </div>
      <div>
        <div class="--label">{{ getLocalization('Services') }}</div>
        <div class="filter-button-group">
          <div :class="filterType === 1 ? 'active' : ''" @click="filterType = 1">{{ getLocalization('Popular') }}</div>
          <div :class="filterType === 2 ? 'active' : ''" @click="filterType = 2">{{ getLocalization('All services') }}</div>
        </div>
      </div>
      <div>
        <div class="--label">{{ getLocalization('Search by service') }}</div>
        <label class="input-search">
          <input v-model="searchServices" type="text" :placeholder="getLocalization('Search by service')">
          <img src="/img/svg/common/search-black.svg" alt=""/>
        </label>
      </div>
    </div>
    <p v-if="allListByCountry.length" class="price-regulator-p">{{getLocalization('Please note that all services are active by default in the sale and are priced at the maximum rates')}}</p>
    <p v-if="allListByCountry.length" class="price-regulator-p mt-4">{{getLocalization('Change the prices for all services')}}:</p>



    <div v-if="allListByCountry.length" class="d-flex flex-wrap mt-4 gap-2 justify-content-between">
      <button
              @click="changeAllWithLoader('active')"
              class="button primary market-btn">
        {{getLocalization('Put all in active')}}
      </button>
      <button
          @click="changeAllWithLoader('disable')"
          class="button primary btn-danger market-btn">
        {{getLocalization('Disable all')}}
      </button>
      <button
          @click="changeAllWithLoader('setMin')"
          class="button market-btn mass-price-btn">
        {{getLocalization('Set the minimum price for all')}}
      </button>
      <button style="max-width: 230px"
          @click="changeAllWithLoader('follow_market_price')"
          class="button market-btn mass-price-btn">
        {{getLocalization('Follow the market price for all')}}
      </button>
      <button
          @click="changeAllWithLoader('setMax')"
          class="button market-btn mass-price-btn active">
        {{getLocalization('Set the maximum prices for all')}}
      </button>
    </div>

    <div v-if="allListByCountry.length" class="price-regulator-page__list" id="service-regulation">
      <div v-for="(service, index) in searchList"
           :class="[
               'price-regulator-card collapse',
               (service['banned_to'] && service['banned_to'] > nowTimeStamp || service['block_type'] === 2) ? 'off' : ''
           ]"
           :id="'price-regulator-card-' + index" data-bs-parent="#service-regulation"
           aria-expanded="false" data-bs-toggle="collapse"
      >
        <div class="price-regulator-card__main">
          <div class="--service">
            <img :src="service['service']['img_path']" :alt="service['service']['title']">
            {{ service['service']['title'] }}
            <div
                v-if="!service.isEditing"
                @dblclick="showEditForm(service)"
            >
              <pre style="overflow: hidden">{{ ' - ' + service['service_code'] }}</pre>
            </div>

          </div>
          <div
              class="--price"
              @dblclick="showEditForm(service)"
              v-if="!service.isEditing"
          >
            {{ service['wholesale_price'] }}₽
          </div>
          <input
              v-if="service.isEditing"
              type="text"
              v-model="service.codeInput"
              @blur="saveServiceCode(service)"
              @keyup.enter="saveServiceCode(service)"
              @keyup.esc="service.isEditing = false"
              class="price-input"
          />
          <input
              v-if="service.isEditing"
              type="number"
              v-model="service.priceInput"
              @blur="savePrice(service)"
              @keyup.enter="savePrice(service)"
              @keyup.esc="service.isEditing = false"
              class="price-input"
          />
<!--          <div class="&#45;&#45;price">-->
<!--            {{ service['wholesale_price'] }}₽-->
<!--          </div>-->
          <div class="--mobile-divider"></div>
          <div class="price-regulator-card__slider">
            <div class="--range">
              <input v-model="service['wholesale_price']"
                     min="0.3" type="range" step="0.01"
                     :max="service['max_partner_price']"
                     @change="changeItemWithLoader({id: service['id'], wholesale_price: service['wholesale_price']})"/>
              <div class="--line"></div>
              <div class="--active-line" :style="'width: ' + getPercent(service['max_partner_price'], service['wholesale_price']) +'%'"></div>
            </div>
            <div class="--info">
              <span class="--min-max"
                    :class="{'min-max-hidden': getPercentWithAdd(service['max_partner_price'], service['default_wholesale_price'], service['wholesale_price']) < 7}"
              >{{ parseFloat(service['default_wholesale_price']) === 0.3 ? '' : 0.3 }}</span>
              <span @click="service['wholesale_price'] = service['default_wholesale_price']; changeItemWithLoader({id: service['id'], wholesale_price: service['default_wholesale_price']})"
                    class="--market"
                    :class="{
                    'market-mobile-baseline': getPercentWithAdd(service['max_partner_price'], service['default_wholesale_price'], service['wholesale_price']) < 7,
                    'market-mobile-end': getPercentWithAdd(service['max_partner_price'], service['default_wholesale_price'], service['wholesale_price']) > 95
                    }"
                    :style="'left: ' + getPercentWithAdd(service['max_partner_price'], service['default_wholesale_price'], service['wholesale_price']) + '%'">
                <img src="/img/svg/price-regulator/triangle.svg">
                <div class="set-market-price">{{ service['default_wholesale_price'] }}</div>
                <span class="set-market-price">{{ getLocalization('MARKET PRICE') }}</span>
              </span>
              <span class="--min-max"
                    :class="{'min-max-hidden': getPercentWithAdd(service['max_partner_price'], service['default_wholesale_price'], service['wholesale_price']) > 95}"
              >{{ parseFloat(service['max_partner_price']) === parseFloat(service['default_wholesale_price']) ? '' : service['max_partner_price'] }}</span>
            </div>
            <div v-if="service['block_type'] === 2" class="banned-regulator">
              {{ getLocalization('Blocked') }}
            </div>
            <div v-else-if="service['banned_to'] && service['banned_to'] > nowTimeStamp"
                 class="banned-regulator">
              {{ getLocalization('Banned till') }}
              <span v-if="service['banned_time']">{{ service['banned_time'] }}</span>
            </div>
            <div v-else-if="service['blocked']"
                 class="banned-regulator">
              {{ getLocalization('Disabled from sale') }}
              <span v-if="service['banned_time']">{{ service['banned_time'] }}</span>
            </div>
            <div class="price-regulator-card__additionally-new">
              <div class="price-regulator-card__additionally-cards">
                <div v-for="(one, index) in availablePrices" class="additionally-cards__card">
                  <div class="card__price">{{ one['price'] }} ₽</div>
                  <div class="card__quantity">{{ one['count'] }} {{ getLocalization('pcs') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="--buttons market-buttons">
              <button v-if="!service['blocked'] && Number(service['follow_market_price']) !== 1"
                      @click="service['wholesale_price'] = service['default_wholesale_price'];
                      service['follow_market_price'] = 1;
                      changeItemWithLoader({id: service['id'], wholesale_price: service['default_wholesale_price'], follow_market_price: true})"
                      class="button market-btn mass-price-btn active w-100">
                {{getLocalization('Follow the market price')}}
              </button>
              <button v-if="!service['blocked'] && Number(service['follow_market_price']) === 1"
                      @click="service['follow_market_price'] = 0; changeItemWithLoader({id: service['id'], wholesale_price: service['wholesale_price'], follow_market_price: false})"
                      class="button primary market-btn market-price-set w-100">
                {{getLocalization('Unfollow market price')}}
              </button>
            </div>
            <div class="--buttons mt-2">
              <button
                  data-bs-toggle="collapse"
                  :data-bs-target="'#price-regulator-card-' + index"
                  class="button primary --small"
                  @click="showCompetitiveInfo(service['id']);"
              >
                <span class="--open">{{ getLocalization('Prices') }} <br/>{{ getLocalization('сompetitor') }}</span>
                <span class="--close">{{ getLocalization('Hide') }} <br/>{{ getLocalization('price') }}</span>
                <img src="/img/svg/common/arrow-down-thin.svg">
              </button>
              <button v-if="service['blocked']"
                      @click="changeItemWithLoader({id: service['id'], blocked: 0, wholesale_price: service['wholesale_price']}); service['blocked'] = !service['blocked']"
                      class="button primary btn-danger">
                {{ getLocalization('Blocked') }}
              </button>
              <button v-else
                      @click="changeItemWithLoader({id: service['id'], blocked: 1, wholesale_price: service['wholesale_price']}); service['blocked'] = !service['blocked']"
                      class="button primary">
                {{ getLocalization('Active') }}
              </button>
            </div>
          </div>

        </div>
        <div class="price-regulator-card__additionally">
          <div class="--left">
            <div class="--min-max">0.3</div>
            <div class="--message-competitor" v-html="getLocalization('Competitive prices')">
            </div>
          </div>
          <div class="--center">
            <div class="price-regulator-card__slider">
              <div class="--range">
                <input v-model="service['wholesale_price']"
                       min="0.3" type="range" step="0.01"
                       :max="service['max_partner_price']"
                       @change="changeItemWithLoader({id: service['id'], wholesale_price: service['wholesale_price']})"/>
                <div class="--line"></div>
                <div class="--active-line" :style="'width: ' + getPercent(service['max_partner_price'], service['wholesale_price']) +'%'"></div>
              </div>
              <div class="--info">
                <span @click="service['wholesale_price'] = service['default_wholesale_price']; changeItemWithLoader({id: service['id'], wholesale_price: service['default_wholesale_price']})" class="--market" :style="'left: ' + getPercentWithAddAdditional(service['max_partner_price'], service['default_wholesale_price'], service['wholesale_price']) + '%'">
                  <img src="/img/svg/price-regulator/triangle.svg">
                  <div class="set-market-price">{{ service['default_wholesale_price'] }}</div>
                  <span class="set-market-price">{{ getLocalization('MARKET PRICE') }}</span>
                </span>
              </div>
            </div>
            <div class="--info">
              <div v-for="(one, index) in availablePrices" :style="'left:'+ getPercent(service['max_partner_price'], one['price']) +'%'" class="--competitor">
                <div>{{ one['price'] }} ₽</div>
                <span>{{ one['count'] }} {{ getLocalization('pcs') }}</span>
              </div>
            </div>
          </div>
          <div class="--right">
            <div class="--min-max">{{ service['max_partner_price'] ?? service['wholesale_price'] }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="price-regulator-page__no-select">
      <img src="/img/svg/common/earth.svg" alt="">
      <span>{{ getLocalization('Select country') }} <br/>{{ getLocalization('to start') }}</span>
    </div>
  </div>
</template>

<script>

import BaseSendRequestMixin from "../../../../components/mixins/BaseSendRequestMixin.vue";
import BaseLoaderMixin from "../../../../components/mixins/BaseLoaderMixin.vue";
import BaseMessagingMixin from "../../../../components/mixins/BaseMessagingMixin.vue";
import Multiselect from "vue-multiselect";
import Modal from "../../../../components/table/modalNew.vue";

export default {
  name: "regulator",
  mixins: [
    BaseSendRequestMixin,
    BaseMessagingMixin,
    BaseLoaderMixin
  ],
  components: {
    Modal,
    Multiselect
  },
  props: [
    'countries'
  ],
  data: function () {
    return {
      availablePrices: [],
      countriesList: [],
      country: null,
      filterType: 1,
      searchServices: '',
      allListByCountry: [],
      nowTimeStamp: 0,
      massUpdateType: null,
      showModalAdd: false,
      isEditing: false,
      priceInput: null
    };
  },

  async mounted() {
    this.getAvailableCountries();
    this.nowTimeStamp = Math.floor(Date.now() / 1000);
  },

  methods: {
    showEditForm(service) {
      // Инициализируем свойства, если они не существуют
      if (!service.hasOwnProperty('isEditing')) {
        this.$set(service, 'isEditing', false);
      }
      if (!service.hasOwnProperty('priceInput')) {
        this.$set(service, 'priceInput', null);
      }
      if (!service.hasOwnProperty('codeInput')) {
        this.$set(service, 'codeInput', null);
      }
      // Активируем режим редактирования для конкретного сервиса
      service.priceInput = service.wholesale_price;
      service.codeInput = service.service_code;
      service.isEditing = true;
    },
    savePrice(service) {
      if (service.priceInput !== null && service.isEditing === true) {
        this.changeItemWithLoader({id: service.id, wholesale_price: service.priceInput});
      }
      service.isEditing = false;
    },
    saveServiceCode(service) {
      if (service.codeInput !== null && service.isEditing === true) {
        this.changeItemWithLoader({id: service.id, service_code: service.codeInput});
      }
      service.isEditing = false;
    },
    getAvailableCountries() {
      let list = this.countries;
      this.countriesList = list.map(el => {
        el.title = this.getLocalization(el.title);
        return el;
      });
    },
    setFilteredList(response) {
      this.allListByCountry = response.data;
    },

    async getList() {
      await this.doWithStopRequest(async () => {
        let params = {
          filterType: this.filterType,
          countryId: this.country.id
        };
        let response = await this.sendRequest(
            '/cabinet/partner/activations/regulator/getList',
            'get',
            params);
        if (response) {
          this.setFilteredList(response);
        }
      });
    },

    async changeItemWithLoader(params) {
      await this.doWithStopRequest(() => this.doWithLoader(async () => {
        let index = this.getIndexByProp(this.allListByCountry, 'id', params['id']);
        let response = await this.sendRequest(
            '/cabinet/partner/activations/regulator/updatePrice',
            'post',
            params
        );

        if (response) {
          await this.alertMessage(
              this.getLocalization('Item has been changed'),
              'info'
          );
          if (response['data']) {
            for (let key in response['data']) {
              this.allListByCountry[index][key] = response['data'][key];
            }
          }
        }
      }), 'Update price')
    },
    async sendChangeAllWithLoader() {
      try {
        await this.doWithStopRequest(() => this.doWithLoader(async () => {
          let filteredServiceVariationsIds = this.searchList.map(function (elem) {
            return elem['id'];
          });
          let params = {
            type: this.massUpdateType,
            ids: filteredServiceVariationsIds
          };
          let response = await this.sendRequest(
              '/cabinet/partner/activations/regulator/massUpdate',
              'post',
              params
          );
          if (response) {
            await this.alertMessage(
                'Items have been changed',
                'info'
            );
          }
        }), 'Update price');
        await this.getList();
        this.toggleShowModalAdd();
      } catch (e) {
        await this.alertMessage(
            'Error',
            'error'
        );
      }
    },
    changeAllWithLoader(type) {
      this.massUpdateType = type;
      this.toggleShowModalAdd();
    },

    async showCompetitiveInfo(variationId) {
      this.availablePrices = [];
      let response = await this.sendRequest('/cabinet/partner/activations/regulator/getCount', 'get', {serviceVariationId: variationId});
      this.availablePrices = response;
    },
    changeCountryId() {
      this.getList();
    },
    getPercent(max, number, min = 0.3) {
      return Math.floor(((number - min) / (max - min)) * 100);
    },
    getPercentWithAdd(max, number, wholesalePrice) {
      if (parseFloat(wholesalePrice) === 0.3 && parseFloat(number) === 0.3) {
        return 2;
      }
      return this.getPercent(max, number);
    },
    getPercentWithAddAdditional(max, number, wholesalePrice) {
      if (parseFloat(wholesalePrice) === 0.3 && parseFloat(number) === 0.3) {
        return 1.1;
      }
      return this.getPercent(max, number);
    },
    getIndexByProp(list, propKey, propValue) {
      for (let key in list) {
        if (list[key][propKey] == propValue) {
          return key;
        }
      }
      return null;
    },
    toggleShowModalAdd() {
      this.showModalAdd = !this.showModalAdd;
    },
  },
  watch: {
    filterType(newValue) {
      this.filterType = newValue;
      if (this.country) {
        this.getList();
      }
    }
  },
  computed: {
    searchList() {
      if (!this.searchServices) {
        return [...this.allListByCountry];
      }

      const search = (this.searchServices || '').trim().toLowerCase();
      this.allListByCountry.forEach(service => {
        this.$set(service, 'isEditing', false);
        this.$set(service, 'priceInput', null);
        this.$set(service, 'codeInput', null);
      });

      return this.allListByCountry.filter(s => s.service.title && s.service.title.toLowerCase().includes(search));
    },
  }
}
</script>
